import { atom } from "recoil";

export const mfaCompliance = atom<boolean | undefined>({
    default: undefined,
    key: "system.mfa-compliance"
});

